<template>
  <div v-if="isAfficher" class="box mb-2" :class="jel_getClassObject(content)">
    <!-- Un lien de retour spécifique a été attribué -->
    <b-link
      v-if="lienExiste"
      v-bind="jel_getLienBinding(content.lien)"
      class="lien-retour btnVide p-0"
    >
      <svg-icon
        icon-name="fleche-gauche"
        className="icone-fleche mySvg"
        :class="content.lien.cssIcone"
      ></svg-icon>
      <span class="graphik_semibold lien-retour pl-0 pt-sm-n1">{{
        content.texteRetour || $t('precedent')
      }}</span>
    </b-link>
    <!-- Ancien code pour la bouton retour utilisant le browser history (si aucun lien est défini) -->
    <button
      v-else-if="isAfficherLienPrecedent"
      data-precedent="precedent"
      class="lien-retour btnVide p-0"
      @click="jel_traiterRetour()"
    >
      <svg-icon icon-name="fleche-gauche" className="icone-fleche mySvg"></svg-icon>
      <span class="graphik_semibold textRetour pl-0 pt-sm-n1">{{
        content.texteRetour || $t('precedent')
      }}</span>
    </button>
  </div>
</template>
<script>
import { bus } from '@/main';
import { mixinEnvironnement } from '@/mixins/mixinEnvironnement';

export default {
  name: 'LienRetour',
  mixins: [mixinEnvironnement],
  props: { content: { type: Object, required: true } },
  computed: {
    isAfficher() {
      // Si "false", le lien retour s'affiche dans l'entête
      return (
        this.mixinEnvironnement_inAppMobile ||
        (!this.$isMobile() &&
          (this.content.appareil == 'desktop' || this.content.appareil == 'tous'))
      );
    },
    lienExiste() {
      return (
        this.content.lien && this.content.lien.field && this.content.lien.field !== 'aucunLien'
      );
    },
    isAfficherLienPrecedent() {
      return this.content.cacherLienInvalide !== 'true' || this.jel_historiqueRouteurPresent();
    },
  },
  mounted() {
    if (!this.isAfficher) {
      bus.$emit('hasRetour', true);
    }
  },
  destroyed() {
    bus.$emit('hasRetour', false);
  },
};
</script>

<style lang="scss" scoped>
.compteClair svg ::v-deep use {
  filter: none;
}

.textRetour {
  line-height: 2em;
  vertical-align: middle;
}

/* ajout du css pour que le b-link se comporte de la même façon que le bouton original  */
.lien-retour:hover {
  text-decoration: none;
}

.icone-fleche {
  margin-right: 4px;
}
</style>
